import React from 'react'
import Link from 'gatsby-link'

import Banner from '../components/banner'
import Sectiontitle from '../components/sectionTitle'

import Button from '../components/button'

import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faPhoneSquare } from '@fortawesome/fontawesome-free-solid'

import meadow from '../images/meadow.png'


const About = () => ( 
  <div className="about">
    <Banner type="about" title="About Us" />

    <section className="page-grid">
      	<section className="page-grid-section">
          	<div className="container">
            	<div className="text-center intro-div">
              		<Sectiontitle title="Ofsted Registered Childminder" />
					<div className="rc-copy regular margin-bottom">
						Rated as 'Good'
					</div>

					<div className="rc-copy small">
					I am an Ofsted registered childminder based in the heart of Oxford. I provide excellent quality training in a safe and  friendly environment. I have many years experience in childminding with excellent references.
					<br/><br/>
					I live in an area overlooking a meadow with a great walking route and nature walks which are a great source of education and discovery for children.
					<br/><br/>
					Current paediatric first aid certificate; Generalist safeguarding; Specialist safeguarding;<br/>EYFS stage 1.
					</div>
            	</div>
          	</div>
        </section>
    </section>

	<section className="page-grid grey key-info">
      	<section className="page-grid-section">
          	<div className="container">
            	<div className="row">
					<div className="col-sm-4">
						<Sectiontitle title="Availability" color="black" />
						<div className="rc-copy small">
							Feel free to contact me to discuss further details of availability.
						</div>
						<br/>
						<Button text="Contact Now" link="/contact-us/" action="true" />
					</div>
					<div className="col-sm-4">
						<Sectiontitle title="Working Hours" color="black" />
						<div className="opening-times">
							8 AM - 5:30 PM
						</div>
						<div className="rc-copy small">
							We would be happy to discuss more flexible timings if required.
						</div>
					</div>
					<div className="col-sm-4">
						<Sectiontitle title="Age Ranges" color="black" />
						<div className="price-tag">
							<span>0 - 5</span> <small>years</small>
						</div>
					</div>
				</div>
          	</div>
        </section>
    </section>

	<section className="page-grid about-blocks-div">
      	<section className="page-grid-section">
			<div className="container">
				<div className="row">
					<div className="col-lg-6">
						<img src={meadow} />
					</div>
					<div className="col-lg-6">
						<div className="about-blocks">
							<Sectiontitle title="When is childcare available?" color="black" />
							<div className="rc-copy small">
							All Year, Christmas holidays, Emergency Cover, Half-term holidays, Negotiable, 
							Spring holiday, Summer holiday
							</div>
						</div>

						<div className="about-blocks">
							<Sectiontitle title="Facilities" color="black" />
							< div className = "rc-copy small">
							Arts and crafts, 
							Computer, 
							Cooking, 
							Dressing up, 
							Educational Toys, 
							Large Garden, 
							Messy Play Area, 
							Quiet room / area, 
							Sleeping Area, 
							Visit &amp; Outings
							</div>
						</div>

						<div className="about-blocks">
							<Sectiontitle title="Pickups" color="black" />
							<div className="rc-copy small">
								<p>Offers pickups: Yes</p>
								<p>Details: Local schools,nurseries and pre-schools</p>
							</div>
						</div>
					</div>
				</div>
			</div>
        </section>
    </section>
  </div>
)

export default About



// WEBPACK FOOTER //
// ./src/pages/about.js